import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import moment from 'moment';
import { sentry } from 'sentry';
var DialogReopenMaintenanceComponent = /** @class */ (function () {
    function DialogReopenMaintenanceComponent(data, matDialogRef, fuseProgressBarService, customMessageService, maintenancesApi, formBuilder) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseProgressBarService = fuseProgressBarService;
        this.customMessageService = customMessageService;
        this.maintenancesApi = maintenancesApi;
        this.formBuilder = formBuilder;
        this.refreshDatatable = false;
    }
    DialogReopenMaintenanceComponent.prototype.ngOnInit = function () {
        this.maintenance = this.data.maintenance;
        this.isViewMode = this.data.isViewMode;
        this.reopenMaintenancesForm = this.formBuilder.group({
            id: this.maintenance.id ? this.maintenance.id : null,
            status: this.maintenance.status ? this.maintenance.status : null,
            number: new FormControl({ value: this.maintenance.number, disabled: true }, [Validators.required]),
            type: new FormControl({ value: this.maintenance.maintenanceType && this.maintenance.maintenanceType.name, disabled: true }, [Validators.required]),
            openedDate: new FormControl({ value: moment(this.maintenance.openedAt).toDate(), disabled: true }, [Validators.required]),
            openedTime: new FormControl({ value: moment(this.maintenance.openedAt).format('HH:mm'), disabled: true }, [Validators.required]),
            segment: new FormControl({ value: this.maintenance.segment, disabled: true }, [Validators.required]),
            scheduleSuggestions: this.maintenance.scheduleSuggestions && this.maintenance.scheduleSuggestions.length > 0 ? new FormArray(this.maintenance.scheduleSuggestions.map(function (scheduleSuggestion) { return new FormControl(scheduleSuggestion); })) : new FormArray([]),
            scheduleSuggestionsStatus: this.maintenance.scheduleSuggestionsStatus ? this.maintenance.scheduleSuggestionsStatus : null,
            reopenReason: new FormControl(null, [Validators.required])
        });
    };
    DialogReopenMaintenanceComponent.prototype.ngOnDestroy = function () {
        this.matDialogRef.close(this.refreshDatatable);
    };
    DialogReopenMaintenanceComponent.prototype.reopenMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        this.isReopenMaintenance = true;
                        return [4 /*yield*/, this.maintenancesApi.reopenMaintenance({
                                id: this.maintenance.id,
                                reopeningReason: this.reopenMaintenancesForm.get('reopenReason').value,
                                scheduleSuggestions: this.reopenMaintenancesForm.get('scheduleSuggestions').value.map(function (scheduleSuggestion) {
                                    var date = moment.utc(scheduleSuggestion.date).format('YYYY-MM-DD');
                                    return { date: date, time: scheduleSuggestion.time };
                                })
                            }).then(function () {
                                _this.customMessageService.success('MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.SAVE_SUCCESS');
                            }).catch(function (err) {
                                sentry.captureException(err);
                                _this.customMessageService.error('MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.SAVE_FAILED');
                            }).finally(function () {
                                _this.fuseProgressBarService.hide();
                                _this.refreshDatatable = true;
                                _this.isReopenMaintenance = false;
                                _this.matDialogRef.close(true);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DialogReopenMaintenanceComponent;
}());
export { DialogReopenMaintenanceComponent };
